module.exports = __webpack_public_path__ + "img/investments-icon.3c4a6527.svg";